/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import ApiRequests from '../../../utils/RequestBody';
import Urls from '../../../utils/urls';
import apiBackendInstance from '../../../utils/axios';
import AuthorizeComponent from './AuthorizeComponent';
import GuideComponent from './GuideComponent';
import StatusComponent from './StatusComponent';
import IdPComponent from './IdPInfoComponent';

interface props{
    id:string
}
export function updateStateForCrossWindowChanges() {
  const localVal = localStorage.getItem('updateState');
  if (localVal && localVal === 'yes') { localStorage.setItem('updateState', 'no'); } else {
    localStorage.setItem('updateState', 'yes');
  }
}
const TencentBody = ({ id }:props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const status = queryParams.get('status');
  if (status && (status === 'success' || status === 'fail')) {
    setTimeout(() => {
      updateStateForCrossWindowChanges();
      window.close();
    }, 3000);
  }
  const [nameAndCredLabel, setNameAndCredLabel] = useState<{
    name:string;
    credlabel:string;
  }>({
    name: '',
    credlabel: '',
  });

  const [providerIdAndRoleArn, setProviderIdAndRoleArn] = useState<{
    providerId:string;
    roleArn:string;
  }>({
    providerId: '',
    roleArn: '',
  });
  const [renderComponent, setRenderComponent] = useState<'status'|'guide'|'authorize'|'idpdata'>(status ? 'status' : 'guide');
  const [handleAuthorizeCloudButtonEvent, toggleAuthorizeCloudButton] = useState('');
  const setDataFromAuthorizeComponent = (name:string, credlabel:string):void => {
    setNameAndCredLabel({
      name, credlabel,
    });
    toggleAuthorizeCloudButton(`${Math.random()}`);
  };

  const handleNavigationFromGuideComponent = () => {
    setRenderComponent('idpdata');
  };

  const handleNavigationForIdp = (navigateTo:'back'|'next', data?:{providerId:string, roleArn:string}) => {
    switch (navigateTo) {
      case 'back':
        setRenderComponent('guide');
        break;

      case 'next':
        if (data) {
          setProviderIdAndRoleArn(data);
          setRenderComponent('authorize');
        }
        break;
      default:
    }
  };

  const validate = () => {
    let flag = true;
    if (nameAndCredLabel.name === ''
     || nameAndCredLabel.credlabel === ''
     || providerIdAndRoleArn.providerId === ''
     || providerIdAndRoleArn.roleArn === '') {
      flag = false;
    }
    return flag;
  };

  useEffect(() => {
    if (validate()) {
      create();
    }
  }, [handleAuthorizeCloudButtonEvent]);
  const handleNavigationForAuthorizeComponent = ():void => {
    setRenderComponent('idpdata');
  };
  const getRenderableComponent = (componentName:'status'|'guide'|'authorize'|'idpdata') => {
    switch (componentName) {
      case 'authorize':
        return (
<AuthorizeComponent
        setData={setDataFromAuthorizeComponent}
         roleArn={providerIdAndRoleArn.roleArn}
          providerId={providerIdAndRoleArn.providerId}
          back={handleNavigationForAuthorizeComponent}
/>
        );
      case 'guide':
        return (<GuideComponent next={handleNavigationFromGuideComponent} />);

      case 'idpdata':
        return (<IdPComponent setData={handleNavigationForIdp} />);

      case 'status':
        return (<StatusComponent status={status as string} />);

      default:
        return (<></>);
    }
  };

  const create = () => {
    const createBtn:any = document.getElementById('createBtn');
    const spinnerDiv = document.getElementById('spinnerDiv');
    const { credlabel, name } = nameAndCredLabel;
    const { providerId, roleArn } = providerIdAndRoleArn;
    if (createBtn) {
      createBtn.disabled = true;
    }
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(Urls.createCloudAuthorizationById(id),
      {
        data: ApiRequests.createTencentCloudAuthorizationBody(
          credlabel, name, providerId, roleArn,
        ),
      }).then((response) => {
      const { data } = response;
      if (data.success) {
        updateStateForCrossWindowChanges();
        if (createBtn) {
          createBtn.disabled = false;
        }
        if (spinnerDiv) {
          spinnerDiv.style.display = 'none';
        }
        const div2 = document.getElementById('succ');
        if (div2) div2.style.display = 'block';
        const url = data.data.redirectURL;
        window.location = url;
      }
    }).catch(() => {
      setTimeout(() => { window.close(); }, 3000);
      updateStateForCrossWindowChanges();
      if (createBtn) {
        createBtn.disabled = false;
      }
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      const div2 = document.getElementById('fail');
      if (div2) div2.style.display = 'block';
    });
  };

  return (
        <>
        <div id="status" />
            <main>
              {
                getRenderableComponent(renderComponent)
              }
            </main>
        </>
  );
};
export default TencentBody;